import { IconNfc } from '@tabler/icons';

const icons = {
    IconNfc
};

// ==============================|| ARCSA MENU ITEMS - DOCTOR ||============================== //

const arcsa = {
    id: 'arcsa',
    title: '',
    type: 'group',
    children: [
        {
            id: 'arcsa_menu',
            title: 'Arcsa',
            type: 'collapse',
            icon: icons.IconNfc,
            children: [
                {
                    id: 'lista_muestra_productos',
                    title: 'Muestra Productos',
                    type: 'item',
                    url: '/user/list-arcsa-muestra-productos'
                },
                {
                    id: 'nueva_muestra_productos',
                    title: 'Nueva Muestra Productos',
                    type: 'item',
                    url: '/user/new-arcsa-muestra-productos/0'
                },
                {
                    id: 'lista_tipos_defectos',
                    title: 'Tipos Defectos',
                    type: 'item',
                    url: '/user/list-arcsa-tipos-defectos'
                },
                {
                    id: 'nuevo_tipo_defecto',
                    title: 'Nuevo Tipo Defecto',
                    type: 'item',
                    url: '/user/new-arcsa-tipos-defectos/0'
                },
                {
                    id: 'lista_nivel_inspeccion',
                    title: 'Nivel Inspección',
                    type: 'item',
                    url: '/user/list-arcsa-nivel-inspeccion'
                },
                {
                    id: 'nuevo_nivel_inspeccion',
                    title: 'Nuevo Nivel Inspección',
                    type: 'item',
                    url: '/user/new-arcsa-nivel-inspeccion/0'
                },
                {
                    id: 'configuracion_reporte',
                    title: 'Configuración Reporte',
                    type: 'item',
                    url: '/user/arcsa-configuracion-reporte'
                }
            ]
        }
    ]
};

export default arcsa;
